// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"Caa-z","categoryName":"Daa-z","categoryImage":"Eaa-z","categoryContent":"Faa-z","bottomAligned":"Gaa-z"};